import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { Container } from 'app/models/container.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';
import { User } from 'app/models/user.model';
import { CompanyService } from 'app/services/company.service';
import { ContainerService } from 'app/services/container.service';
import { PoligonService } from 'app/services/poligon.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from "../../base-form.component";

@Component({
    selector: "mia-garbage-center-form",
    templateUrl: "./garbage-center.component.html",
    styleUrls: ["./garbage-center-form.component.css"]
})

export class GarbageCenterFormComponent extends BaseFormComponent implements OnInit {

    /** */
    @Output() public close = new EventEmitter();
    @Output() public done = new EventEmitter();

    public selectedCompany: number;
    public companyId:number;
    public companyList: Array<Company>;
    public get model(): any {
        return this._data;
    }
    private _polygonList: Array<Poligon>
    public get polygonList(): Array<Poligon> {
        return this._polygonList;
    }

    public container: Container = {
        street: undefined,
        streetDesc: undefined,
        neighbor: undefined,
        rootType: undefined,
    }
    public selectedContainerId: number;

    private _selectedPolygons: Array<Poligon>=[];
    public get selectedPolygons(): Array<Poligon> {
        return this._selectedPolygons;
    }
    public set selectedPolygons(v: Array<Poligon>) {
        this._selectedPolygons = v;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _toasterService: ToasterService,
        private _containerService: ContainerService,
        private _translateService: TranslateService,
        private _polygonService: PoligonService,
        private _companyService: CompanyService,
        private _poligonService:PoligonService,
        private _dialogRef: MatDialogRef<GarbageCenterFormComponent>) {
        super();
    }


    public async ngOnInit(): Promise<void> {
        debugger
        try {
            this.companyId= parseInt(localStorage.getItem("CompanyID"))

            if (this.companyId == 1) {
                this.companyList = await this._companyService.getCompanies();
            }

            await this.getPoligonList(this.selectedCompany ? this.selectedCompany : this.companyId);
            
            var containerList = await this._poligonService.getByPoligonDetail(this.container.id);
            
            containerList.forEach(x=>{
                this.selectedPolygons.push(this.polygonList.find(y=>y.id==x.poligonId));
                this.selectedPolygons = [...this.selectedPolygons]
            })
        } catch (error) {
            console.warn(error);
        }
    }

    public async onCompanyChange(id){
        this.getPoligonList(id);
    }

    public async getPoligonList(companyId:number){
        try {
            this._polygonList = await this._poligonService.getPoligons(companyId);
        } catch (error) {
            console.warn(error);
        }
    }

    public async save(): Promise<void> {

        if(this.form.invalid){
            this._toasterService.toastFail(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }

        if (this.operation == "update") {
            try {
                this.container.street = this.container.streetDesc;
                this.container.name = this.container.name;
                this.container.neighbor = this.container.streetDesc;
                this.container.companyId = this.companyId == 1 ? this.selectedCompany : this.companyId
                try {
                    this._containerService.updated(this.container);
                    var containerList = await this._poligonService.getByPoligonDetail(this.container.id);
                    await this._poligonService.removeRange(containerList);
                    this.selectedPolygons.forEach(async (x)=>{
                        let poligonDetail = new PoligonDetail();
                        poligonDetail.poligonId = x.id;
                        poligonDetail.discriminator = "garbage-center";
                        poligonDetail.discriminatorId = this.container.id
                        await this._poligonService.addDetail(poligonDetail);
                    })
                    this._dialogRef.close();
                    this.done.emit(true);
                } catch (error) {
                    console.warn(error);
                    this._dialogRef.close();
                    this.done.emit(false);
                }
            } catch (error) {
                console.warn(error);
                this.done.emit(false);
            }
        }
        else {
            try {
                
                this.container.latitude = this._data.lat;
                this.container.longitude = this._data.lng;
                this.container.containerType = true;
                this.container.status = true;
                this.container.name = this.container.streetDesc;
                this.container.street = this.container.streetDesc;
                this.container.neighbor = this.container.streetDesc;
                this.container.companyId = this.companyId == 1 ? this.selectedCompany : this.companyId

                try {
                    const containerAdd = this._containerService.add(this.container);
                    this.selectedContainerId = (await containerAdd).id

                } catch (error) {
                    console.warn(error);

                }
                
                this._dialogRef.close();
                this.done.emit();
            } catch (ex) {
                this.close.emit(ex);
            }

        }
    }

    public cancel() {
        this._dialogRef.close();
        this.close.emit("");
    }


}




